import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
`;

const EmailInput = styled.input`
  font-size: 1.2rem;
  padding: 0.5rem;
  margin: 1rem 0;
  min-width: 300px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

const SubmitButton = styled.button`
  padding: 1rem 2rem;
  font-size: 1.2rem;
  background-color: #ff734f;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #ff734f;
  }
`;

const Title = styled.h1`
  margin-bottom: 1rem;
`;

const Description = styled.p`
  margin-bottom: 2rem;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #ff734f;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${spin} 1s linear infinite;
  margin: 20px 0;
`;

const ErrorMessage = styled.p`
  color: #ff734f;
  margin-top: 1rem;
  font-size: 1rem;
  text-align: center;
`;

const EmailPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const theme = location.state?.searchValue;

  const handleSubmit = async () => {
    setIsLoading(true);
    setError(null);
    //const url = "http://localhost:1020/newsletter";
    const url = "https://api.oparl-app.com/clientsystem/newsletter";
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          theme,
          email,
        }),
      });

      if (!response) {
        throw new Error("No response from server");
      }

      let data;
      try {
        data = await response.json();
      } catch (e) {
        if (response.ok) {
          navigate("/success", { state: { theme, email } });
          return;
        }
        throw new Error("Invalid JSON response");
      }

      if (response.status === 200) {
        navigate("/success", { state: { theme, email } });
      } else if (data.message === "Email already in the database") {
        setError(
          "Vous êtes déjà inscrit à la newsletter avec cette adresse email."
        );
      } else {
        setError(
          "Une erreur est survenue lors de l'inscription. Veuillez réessayer."
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setError(
        "Une erreur est survenue lors de l'inscription. Veuillez réessayer."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <Title>Une dernière étape !</Title>
      <Description>
        Entrez une adresse email valide pour recevoir la newsletter pendant 3
        semaines.
      </Description>

      <EmailInput
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Votre adresse email"
        disabled={isLoading}
      />

      {error && <ErrorMessage>{error}</ErrorMessage>}

      {isLoading ? (
        <Spinner />
      ) : (
        <SubmitButton onClick={handleSubmit}>Valider</SubmitButton>
      )}
    </Container>
  );
};

export default EmailPage;
